"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.spacings = void 0;
const baseSpacings_1 = __importDefault(require("./baseSpacings"));
exports.spacings = {
    ...baseSpacings_1.default,
    AdLink: {
        Content: {
            width: '10.625rem',
            height: '10.625rem',
        },
    },
    CarInfo: {
        Logo: {
            width: '4rem',
            height: '4rem',
        },
    },
    Textarea: {
        width: '50rem',
    },
    Wizard: {
        maxWidth: '50rem',
    },
    Dropdown: {
        scrollbar: { height: '35%', width: '4px' },
    },
};
//# sourceMappingURL=spacings.js.map